import $ from 'jquery';
import axios from 'axios';

export function getInitialState() {
    const reqUrl = '/pro/apps/on_call_air_status';
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'GET',
        headers: reqHeaders
    })
}

export function getOnCallAirApiKey() {
    const reqUrl = '/pro/apps/on_call_air_status';
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'GET',
        headers: reqHeaders
    })
}

export function updateOnCallAirApiKey(onCallAirApiKey) {
    const reqUrl = '/pro/apps/update_on_call_air_api_key/' + onCallAirApiKey;
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'POST',
        headers: reqHeaders
    })
}

export function disableOnCallAir() {
    const reqUrl = '/pro/apps/disable_on_call_air/';
    const reqHeaders = {"X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')};

    return axios({
        url: reqUrl,
        method: 'POST',
        headers: reqHeaders
    })
}
